<template>
    <div class="about-au">
      <p class="indent size-33">НАД 45 ГОДИНИ ОПИТ В ПРОИЗВОДСТВОТО НА АЛУМИНИЕВИ ВАЛЦОВИ И ПРЕСОВИ ПРОДУКТИ</p>

      <h3 class="indent">Фирмен профил</h3>
      <p class="indent">
        „Алкомет“ АД е водещ български производител на алуминиеви валцови и пресови продукти с над 45 години опит в производството на алуминий. Базирана в град Шумен, компанията разполага с интегрирана производствена база, в която се осъществява целият производствен процес – от леене на заготовки и рулони до валцоване, пресоване, повърхностна обработка и прецизна механична обработка.</p>
      <p class="indent">
        С помощта на съвременни технологии и с общ производствен капацитет от 160 000 тона годишно, „Алкомет“ предлага алуминиеви решения за широк спектър от приложения и за клиенти с високи изисквания на световните пазари.
      </p>
      <h3 class="indent">Присъствие на международните пазари</h3>
      <p class="indent">
        „Алкомет“ има силно присъствие на европейския и американския пазар, като обслужва клиенти от секторите строителство и архитектура, автомобилостроене, транспорт, производство на опаковки, машиностроене, дистрибуция и др.
        Компанията неизменно заема позиции сред 100-те водещи български компании по приходи и растеж, както и сред 100-те най-големи работодатели в страната.


      </p>

      <h3 class="indent">Качество, устойчивост и стандарти</h3>
      <p class="indent">Качеството, отговорното отношение към околната среда и оперативната ефективност са неразделна част от производствения подход на „Алкомет“. Компанията е сертифицирана по ISO 9001, ISO 14001, ISO 45001, EN 15088, EN 27001, IATF 16949, QUALANOD, QUALICOAT и ASI Performance Standard V2, както и по други приложими индустриални стандарти.
      </p>
      <p class="indent">
        Непрекъснатите инвестиции в технологии, човешки ресурси и устойчиви производствени процеси позволяват на „Алкомет“ да подобрява качеството на своите продукти, да повишава ефективността при използването на ресурсите и да създава дългосрочна стойност за своите клиенти и партньори.
      </p>

      <p class="indent" style="text-align:center;">
        <img class="w-100" v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/0309_achenbah.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img class="w-100" v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/0309_presezzi.jpg" alt="">
      </p>

      <h3 class="indent">СТРАТЕГИЧЕСКИ ИНВЕСТИЦИИ И ТЕХНОЛОГИЧНО РАЗВИТИЕ</h3>
      <p class="indent">Инвестиционната програма на „Алкомет“ за периода 2023–2026 г., на стойност приблизително 70 млн. евро, значително разшири производствените и технологичните възможности на компанията. Реализираните инвестиции обогатяват продуктовото портфолио и създават нови възможности за производство на алуминиеви продукти с висока добавена стойност.</p>


      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/v1.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/v2.jpg" alt="">
      </p>

        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.w-100 { max-width:100%;}
.size-33 { font-size:35px !important; line-height: 54px; text-indent: inherit; text-align: left !important; padding-bottom:30px;}
h3  {
  text-decoration: underline;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
  font-size:24px;
}
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue